import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';

const json = {
  1: { // Exercise num
    unit: 'Unit 1',
    id: 'WB3-U1-P10-E1',
    audio: '',
    video: '',
    component: UI,
    titleImage: '',
    question: [
    ],
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page10/E1/1.jpg' },
      ],
    ]
  },
  2: { // Exercise num
    unit: 'Unit 1',
    id: 'WB3-U1-P10-E2',
    audio: '',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page10/E2/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page10/E2/1.jpg' },
      ],
      [
        // 2
        { url: 'img/FriendsPlus/Page10/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page10/E2/3.jpg', input: true, answer: "ixteen" },
        { url: 'img/FriendsPlus/Page10/E2/4.jpg' },
      ],
      [
        // 3
        { url: 'img/FriendsPlus/Page10/E2/5.jpg' },
      ],
      [
        // 4
        { url: 'img/FriendsPlus/Page10/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page10/E2/7.jpg', input: true, answer: "welve" },
        { url: 'img/FriendsPlus/Page10/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page10/E2/9.jpg', input: true, answer: "eventeen" },
        { url: 'img/FriendsPlus/Page10/E2/10.jpg' },
      ],
      [
        // 5
        { url: 'img/FriendsPlus/Page10/E2/11.jpg' },
      ],
      [
        // 6
        { url: 'img/FriendsPlus/Page10/E2/12.jpg' },
        { url: 'img/FriendsPlus/Page10/E2/13.jpg', input: true, answer: "hirteen" },
        { url: 'img/FriendsPlus/Page10/E2/14.jpg' },
        { url: 'img/FriendsPlus/Page10/E2/15.jpg', input: true, answer: "ighteen" },
        { url: 'img/FriendsPlus/Page10/E2/16.jpg' },
      ],
      [
        // 7
        { url: 'img/FriendsPlus/Page10/E2/17.jpg' },
      ],
      [
        // 8
        { url: 'img/FriendsPlus/Page10/E2/18.jpg' },
        { url: 'img/FriendsPlus/Page10/E2/19.jpg', input: true, answer: "ourteen" },
        { url: 'img/FriendsPlus/Page10/E2/20.jpg' },
        { url: 'img/FriendsPlus/Page10/E2/21.jpg', input: true, answer: "ineteen" },
        { url: 'img/FriendsPlus/Page10/E2/22.jpg' },
      ],
      [
        // 9
        { url: 'img/FriendsPlus/Page10/E2/23.jpg' },
      ],
      [
        // 10
        { url: 'img/FriendsPlus/Page10/E2/24.jpg' },
        { url: 'img/FriendsPlus/Page10/E2/25.jpg', input: true, answer: "ifteen" },
        { url: 'img/FriendsPlus/Page10/E2/26.jpg' },
        { url: 'img/FriendsPlus/Page10/E2/27.jpg', input: true, answer: "wenty" },
        { url: 'img/FriendsPlus/Page10/E2/28.jpg' },
      ],

    ]
  },
}

export default json;